"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityStatusChip = exports.EmbeddableDataQualityStatusChip = void 0;
var react_1 = __importDefault(require("react"));
var ReactDOM = require("react-dom");
var Localize_1 = require("../../../gen-src/Localize");
var DataCatalogProvider_1 = require("../DataCatalogProvider");
var TelemetrySender_1 = require("../telemetry/TelemetrySender");
var DataQualityDetail_1 = require("./DataQualityDetail");
var DataQualityDetailPanel_1 = require("./DataQualityDetailPanel");
var DataQualityType_1 = require("./DataQualityType");
var DataQualityStatusChipId = 'data-quality-status-chip-id';
/**
 * @deprecated TFS-1478812
*/
function EmbeddableDataQualityStatusChip(props) {
    return (react_1.default.createElement(DataCatalogProvider_1.SiteUrlsProvider, { siteUrls: props.siteUrls },
        react_1.default.createElement(DataQualityStatusChip, __assign({}, props))));
}
exports.EmbeddableDataQualityStatusChip = EmbeddableDataQualityStatusChip;
/**
 * @deprecated TFS-1478812
*/
var DataQualityStatusChip = /** @class */ (function (_super) {
    __extends(DataQualityStatusChip, _super);
    function DataQualityStatusChip(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.setIsDialogOpen = function (isDialogOpen) {
            var _a, _b;
            if (!_this.state.isDialogOpen && isDialogOpen) {
                var event_1 = __assign(__assign({}, _this.state.eventDetails), { content_type: (_b = (_a = _this.props.details.find(function (t) { return t.onContentItem; })) === null || _a === void 0 ? void 0 : _a.assetType) !== null && _b !== void 0 ? _b : 'unknown', elevated: _this.props.details.some(function (d) { return d.isSevere; }), value: _this.props.details.map(function (d) { return (0, DataQualityType_1.localizeDataQualityTypeName)(d.type); }).join(',') });
                TelemetrySender_1.telemetrySender.sendEvent(event_1, {}, 'remove');
            }
            _this.setState({ isDialogOpen: isDialogOpen });
        };
        _this.ref = react_1.default.createRef();
        _this.setRef = function (button) {
            if (button) {
                // eslint-disable-next-line react/no-find-dom-node
                _this.setState({ iconOnlyButtonRef: ReactDOM.findDOMNode(button) });
            }
        };
        _this.state = {
            isDialogOpen: false,
            eventDetails: {
                category: 'warning',
                source: "".concat((_a = props.source) !== null && _a !== void 0 ? _a : DataQualityStatusChipId, "!deprecated"),
                type: 'label_opened',
            },
        };
        return _this;
    }
    DataQualityStatusChip.prototype.render = function () {
        var _this = this;
        if (!this.props || this.props.details.length < 1) {
            return null;
        }
        var isSevere = this.props.details.some(function (d) { return d.isSevere; });
        var text = dataQualityTooltipTitle(this.props);
        var baseProps = { text: text, warningKind: isSevere ? 'severe-warning' : 'standard-warning', testId: DataQualityStatusChipId };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.props.iconOnly ? (react_1.default.createElement(DataQualityDetail_1.DataQualityTooltipButton, __assign({}, baseProps, { kind: 'interactive-icon', setRef: this.setRef, onClick: function () { return _this.setIsDialogOpen(!_this.state.isDialogOpen); }, tabIndex: this.props.iconOnlyTabIndex }))) : (react_1.default.createElement(DataQualityDetail_1.DataQualityTooltipButton, __assign({}, baseProps, { kind: 'interactive-inline', ref: this.ref, onClick: function () { return _this.setIsDialogOpen(!_this.state.isDialogOpen); } }))),
            this.state.isDialogOpen ? (react_1.default.createElement(DataQualityDetailPanel_1.DataQualityDetailPanel, __assign({}, this.props, { title: text, anchorEl: this.props.iconOnly
                    ? (this.state.iconOnlyButtonRef || undefined)
                    : this.ref.current, side: this.props.side || 'right', onCloseRequest: function () { return _this.setState({ isDialogOpen: false }); } }))) : null));
    };
    return DataQualityStatusChip;
}(react_1.default.Component));
exports.DataQualityStatusChip = DataQualityStatusChip;
function dataQualityTooltipTitle(props) {
    if (!props || props.details.length < 1) {
        return '';
    }
    var count = props.details.length;
    if (count === 1) {
        return (0, DataQualityType_1.localizeDataQualityTypeName)(props.details[0].type);
    }
    return Localize_1.Messages.DataQualityIconMessage({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: Localize_1.Formatters.formatCount(count)
    });
}
//# sourceMappingURL=DataQualityStatusChip.js.map